<script setup lang="ts">
defineProps<{ tag: TagItem; color?: PostType }>();
const { getPaletteForPostType } = useTheme();
</script>

<template>
  <div
    :class="[
      'post-content-tags-item',
      'select-none',
      'text-center whitespace-nowrap text-xs leading-[0.875rem]',
      'h-10 px-4 rounded-e-2xl rounded-b-2xl',
      'inline-flex items-center justify-center gap-2',
      ...(color ? [getPaletteForPostType(color).bg] : ['bg-[#F8F8F8]']),
      {
        'text-black': color,
        'text-[#242020]': !color,
      },
    ]"
  >
    <span>{{ tag.title }}</span>
  </div>
</template>
